export default __webpack_public_path__ + "39da3041d7df14c484382762ae99a77e.jpeg";